

import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { ChartsService } from '../../../../services/chartService/charts.service';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    moduleId: module.id,
    selector: 'pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.scss', '../../charts.style.scss']
})

export class PieChartComponent implements OnInit, AfterViewInit {
    @Input() chartSpecification: ChartSpecification;

    constructor() { }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data = this.chartSpecification.data || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "chartdiv";
    }

    ngAfterViewInit() {
        this.drawChart();
    }

    drawChart() {
        setTimeout(() => {
            AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits": "true",
                "type": "pie",
                "theme": this.chartSpecification.theme,
                "dataProvider": [{
                    "title": "New",
                    "value": 4852,
                    "color": "#8c0000"
                }, {
                    "title": "test",
                    "value": 767,
                    "color": "#00ff00"
                }, {
                    "title": "Returning",
                    "value": 9899
                }
                    , {
                    "title": "Returning",
                    "value": 9899
                }, {
                    "title": "Returning",
                    "value": 9899
                }],
                "titleField": this.chartSpecification.xAxis,
                "valueField": this.chartSpecification.yAxis,
                "labelRadius": 5,
                "colorField": "color",
                "radius": "42%",
                "innerRadius": "60%",
                "labelText": "[[title]]",
                "export": {
                    "enabled": true,
                    "fileName": this.chartSpecification.title
                }
            });
        }, 20);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/pie/pie-chart/pie-chart.component.ts